/** Ссылки use-case и гайдов в выпадающем меню шапки. */
export type MarketingNavIconTone = 'primary' | 'secondary' | 'tertiary' | 'neutral';

const MARKETING_USE_CASE_NAV_LINKS = [
  {
    to: '/use-cases/conferences',
    label: 'Конференции',
    description: 'Программа, зал, несколько спикеров',
    iconTone: 'primary' as const,
  },
  {
    to: '/use-cases/presentations',
    label: 'Презентации',
    description: 'Один экран, питч, совещание',
    iconTone: 'secondary' as const,
  },
  {
    to: '/use-cases/timer-event-production',
    label: 'Продакшн-команды',
    description: 'Шоу, трансляции, несколько сцен',
    iconTone: 'tertiary' as const,
  },
  {
    to: '/use-cases/meeting-timer',
    label: 'Совещания',
    description: 'Планёрки, советы, регламент встреч',
    iconTone: 'neutral' as const,
  },
  {
    to: '/use-cases/online-timer-for-education',
    label: 'Уроки и занятия',
    description: 'Таймер для урока, экзамена, класса',
    iconTone: 'secondary' as const,
  },
  {
    to: '/use-cases/stream-timer',
    label: 'Стримы и трансляции',
    description: 'OBS, Twitch, YouTube, турниры',
    iconTone: 'primary' as const,
  },
  {
    to: '/use-cases/broadcast-timer',
    label: 'Эфир и вещание',
    description: 'Прямые эфиры, студия, расписание шоу',
    iconTone: 'tertiary' as const,
  },
  {
    to: '/use-cases/workout-timer',
    label: 'Тренировки и фитнес',
    description: 'Интервалы, HIIT, йога, групповые занятия',
    iconTone: 'neutral' as const,
  },
  {
    to: '/use-cases/trade-show-timer',
    label: 'Выставки и экспо',
    description: 'Выставочная сцена, демо на стенде',
    iconTone: 'secondary' as const,
  },
  {
    to: '/use-cases/webinar-timer',
    label: 'Вебинары',
    description: 'Онлайн-эфиры рядом с Zoom, Teams, YouTube',
    iconTone: 'primary' as const,
  },
  {
    to: '/use-cases/church-timer',
    label: 'Церковь и служения',
    description: 'Проповедь, прославление, порядок служения',
    iconTone: 'neutral' as const,
  },
] as const;

const MARKETING_GUIDE_NAV_LINKS = [
  {
    to: '/guides/timer-rezhimy-sekundomer-i-chasy',
    label: 'Режимы таймера',
    description: 'Секундомер, обратный отсчёт, часы',
    iconTone: 'tertiary' as const,
  },
  {
    to: '/guides/timer-vmesto-vidzheta-na-sajte',
    label: 'Таймер без iframe',
    description: 'Отдельная комната вместо виджета на сайте',
    iconTone: 'neutral' as const,
  },
] as const;

export const MARKETING_NAV_DROPDOWN_LINKS = [
  ...MARKETING_USE_CASE_NAV_LINKS,
  ...MARKETING_GUIDE_NAV_LINKS,
] as const;
